import type { BatchHeader } from '~/features/catalog-operations/types/catalog-operations.types';
import { productClassesTotal } from '~/features/product-groups/utils/product-groups';
import type { RunCostOptions } from '~/features/run-wizard/utils/run-cost';

import { runSetupOf, SOURCE_LOCALE } from './run-setup';

/** The workflow connector code the rates are kept under: META for Meta batches, else GMC. */
export function rateConnectorOf(header: BatchHeader): 'GMC' | 'META' {
  return header.useCase === 'META_ADS' ? 'META' : 'GMC';
}

/**
 * The stepper's cost options rebuilt from a batch's stored run config and product count, for
 * a batch created before its planned cost was stored. Null when the batch has no products to
 * price yet.
 */
export function runCostOptionsOf(header: BatchHeader): RunCostOptions | null {
  const products =
    header.productsCuratedTotal ?? productClassesTotal(header.productClassesIncluded);
  if (!products) return null;
  const setup = runSetupOf(header);
  return {
    products,
    content: setup.attributes.length > 0,
    searchDescriptors: setup.searchDescriptors,
    phraseDescriptions: setup.phraseDescriptions,
    scoringBefore: setup.preScoring,
    scoringAfter: setup.postScoring,
    languages: setup.locales.filter((l) => l !== SOURCE_LOCALE).length,
  };
}
